


























import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    text: {
      type: String,
      required: false,
    },
    content: {
      type: String,
      required: false,
    },
    position: {
      type: String,
      default: 'bottom',
      validator(value: string) {
        return ['top', 'bottom', 'left', 'right'].includes(value);
      },
    },
    backgroundColor: {
      type: String,
      default: 'rgba(0, 0, 0, 0.7)',
    },
    textColor: {
      type: String,
      default: '#fff',
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    tooltipStyle() {
      return {
        backgroundColor: this.backgroundColor,
        color: this.textColor,
      };
    },
  },
  methods: {
    showTooltip() {
      this.visible = true;
    },
    hideTooltip() {
      this.visible = false;
    },
  },
});
